import { Button } from "@mui/material";
import React from "react";
import CustomBotIcon from "../../../app/assets/custom-icons/CustomBotIcon";

const ButtonBot = ({ img, icon, iconText, text, onOpen, ...props }) => {
  return (
    <>
      <div className="flex items-center space-x-4">
        {/* <img
          alt="Immagine"
          src={img ? img : "/img/placeholder-image.svg"}
          style={{
            width: "120px",
            height: "auto",
          }}
        /> */}
        <div className="w-1/3 flex items-center">
          <CustomBotIcon className="w-20 h-20" shadows={false} />
        </div>

        <p className="text-xs w-2/3">{text}</p>
      </div>
      <Button {...props} onClick={onOpen} variant="outlined" startIcon={icon}>
        {iconText}
      </Button>
    </>
  );
};

export default ButtonBot;
